module.exports = __webpack_public_path__ + "static/img/09.b7c7430c.png";